import { AfterViewChecked, Component, ContentChild, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { ButtonIcons } from '../action-button/models/button-icons.enum';

@Component({
	selector: 'action-button-carousel',
	templateUrl: './action-button-carousel.component.html',
	styleUrls: ['./action-button-carousel.component.scss', '../stylesheets/job-actions.scss']
})
export class ActionButtonCarouselComponent implements AfterViewChecked {

	@Input() public showMessageTemplate = false;

	@ContentChild('buttonsTemplate') public buttonsTemplate: TemplateRef<any>;
	@ContentChild('messagesTemplate') public messagesTemplate: TemplateRef<any>;

	// tslint:disable-next-line:variable-name
	@ContentChildren(ActionButtonComponent) public buttons: QueryList<ActionButtonComponent>;

	public buttonCounter = 0;
	public visibleItemsCount = 3;
	public isFullWidth = true;

	public readonly ButtonIcons = ButtonIcons;

	constructor() { }

	public ngAfterViewChecked(): void {
		this.refreshView();
	}

	public refreshView(): void {
		setTimeout(
			() => {
				this.isFullWidth = this.buttons && (this.buttons.length < (this.visibleItemsCount + 1));

				if (this.buttons && (this.buttons.length > (this.visibleItemsCount + 1))) {

					const shownIndexes = [];

					for (let index = 0; index < this.visibleItemsCount; ++index) {
						shownIndexes.push(this.buttonCounter * this.visibleItemsCount + index);
					}

					this.buttons.forEach((item, index) => {
						if (shownIndexes.indexOf(index) > -1) {
							item.elementRef.nativeElement.classList.remove('hidden');
						} else {
							item.elementRef.nativeElement.classList.add('hidden');
						}
					});
				}
			},
			10
		);
	}

	public showNextPage(): void {
		this.buttonCounter = (this.buttonCounter + 1) * this.visibleItemsCount >= this.buttons.length ? 0 : (this.buttonCounter + 1);
		this.refreshView();
	}
}
